import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared';

import { BossComponent } from './containers/boss/boss.component';
import { BossStateModule } from './state/boss-state.module';
import { Month } from './pipes/month.pipe';

@NgModule({
  imports: [CommonModule, BossStateModule, SharedModule],
  declarations: [BossComponent, Month],
})
export class BossModule {}
